export default {
    methods: {
        $can(permissionName) {
            let Permission = this.$store.state.user.authenticated
            if (typeof Permission != 'undefined') {
                return Permission.indexOf(permissionName) !== -1;
            }
        },
    },
};